import { useState } from 'react';
import PageHeader from '@/components/base/PageHeader';
import Card from '@/components/base/Card';
import { Field, Input, Textarea } from '@/components/base/FormField';
import { useApp } from '@/context/AppContext';

function Toggle({ label, description, checked, onChange }: { label: string; description: string; checked: boolean; onChange: (v: boolean) => void }) {
  return (
    <div className="flex items-center justify-between gap-4 py-3">
      <div>
        <p className="text-sm font-semibold text-foreground-900">{label}</p>
        <p className="text-xs text-foreground-500">{description}</p>
      </div>
      <button
        type="button"
        onClick={() => onChange(!checked)}
        className={`relative h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors ${checked ? 'bg-primary-500' : 'bg-background-300'}`}
      >
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white transition-all ${checked ? 'left-[22px]' : 'left-0.5'}`} />
      </button>
    </div>
  );
}

export default function Settings() {
  const { showToast } = useApp();
  const [notifications, setNotifications] = useState({
    overdue: true,
    delivery: true,
    quoteValidity: false,
    purchase: true,
  });

  return (
    <div className="max-w-4xl space-y-5 animate-fade-in-up">
      <PageHeader title="Ayarlar" description="Firma, kullanıcı ve bildirim tercihlerini yönetin." />

      <Card className="p-5">
        <h2 className="font-heading text-base font-semibold text-foreground-950">Firma Bilgileri</h2>
        <form onSubmit={(e) => { e.preventDefault(); showToast('Firma bilgileri kaydedildi'); }} className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field label="Firma Adı"><Input defaultValue="3D Machine Tic. Ltd. Şti." /></Field>
          <Field label="Telefon"><Input defaultValue="0 312 000 00 00" /></Field>
          <Field label="E-posta"><Input type="email" defaultValue="info@3dmachine.com" /></Field>
          <Field label="Vergi Dairesi"><Input defaultValue="Ostim" /></Field>
          <Field label="Vergi No"><Input defaultValue="1234567890" /></Field>
          <Field label="Web Sitesi"><Input defaultValue="www.3dmachine.com" /></Field>
          <Field label="Adres" className="sm:col-span-2"><Textarea defaultValue="OSTİM OSB, Ankara" /></Field>
          <div className="flex justify-end gap-3 sm:col-span-2">
            <button type="submit" className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-600">Kaydet</button>
          </div>
        </form>
      </Card>

      <Card className="p-5">
        <h2 className="font-heading text-base font-semibold text-foreground-950">Kullanıcı</h2>
        <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field label="Ad Soyad"><Input defaultValue="Murat Yılmaz" /></Field>
          <Field label="E-posta"><Input type="email" defaultValue="murat@3dmachine.com" /></Field>
          <Field label="Rol"><Input defaultValue="Genel Müdür" disabled /></Field>
          <Field label="Şifre"><Input type="password" placeholder="••••••••" /></Field>
        </div>
      </Card>

      <Card className="p-5">
        <h2 className="font-heading text-base font-semibold text-foreground-950">Bildirim Tercihleri</h2>
        <div className="mt-2 divide-y divide-background-100">
          <Toggle label="Geciken Tahsilat Uyarıları" description="Alacak vadesi geçtiğinde bildir" checked={notifications.overdue} onChange={(v) => setNotifications((p) => ({ ...p, overdue: v }))} />
          <Toggle label="Teslim Yaklaşan Projeler" description="Teslim tarihine 7 gün kaldığında bildir" checked={notifications.delivery} onChange={(v) => setNotifications((p) => ({ ...p, delivery: v }))} />
          <Toggle label="Teklif Geçerlilik Süresi" description="Teklif süresi dolmadan bildir" checked={notifications.quoteValidity} onChange={(v) => setNotifications((p) => ({ ...p, quoteValidity: v }))} />
          <Toggle label="Bekleyen Satın Alma" description="Satın alma kalemi beklendiğinde bildir" checked={notifications.purchase} onChange={(v) => setNotifications((p) => ({ ...p, purchase: v }))} />
        </div>
      </Card>
    </div>
  );
}